<template>
  <el-main class="home">
    <div class="form-container pa-3">
      <h1>Account Verification</h1>
      <p>You should receive a text message or email with a verification code. Enter it below to continue.</p>
      <el-form :model="verificationForm" status-icon :rules="validationRules" ref="verificationForm" @submit.native.prevent>
        <el-alert
          v-show="errorMessage"
          :title="errorMessage"
          :closable="false"
          show-icon
          type="error"
        />
        <el-form-item label="Verification Code" required prop="verificationCode">
          <el-input v-model="verificationForm.verificationCode" placeholder="Verification Code" v-mask="'######'" inputmode="numeric" @keyup.enter.native="onSubmit" />
        </el-form-item>
        <el-row type="flex" justify="center">
          <el-button v-loading="submitting" class="ma-3" type="primary" round @click="onSubmit">Submit</el-button>
        </el-row>
        <el-row type="flex" justify="center">
          <p>Didn't receive a code? <el-link v-loading="resending" type="info" @click="onResend">Resend</el-link></p>
        </el-row>
      </el-form>
    </div>
  </el-main>
</template>

<script>
import api from '@/api';
import Jwt from '@/model/Jwt';
import jwtService from '@/service/JwtService';

export default {
  components: {},
  props: {
    clientId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      errorMessage: undefined,
      submitting: false,
      resending: false,
      verificationForm: {
        verificationCode: '',
      },
      validationRules: {
        verificationCode: [{
          required: true,
          validator: (rule, value, callback) => {
            if (!value) {
              callback(new Error('Verification Code is required.'));
            } else if (!value.match(/^[0-9]{6}$/i)) {
              callback(new Error('Please enter a valid verification code.'));
            } else {
              callback();
            }
          },
          trigger: 'blur',
        }],
      },
    };
  },
  methods: {
    async onResend() {
      try {
        this.resending = true;
        await api.docutax.resendVerification(this.clientId);
      } catch (e) {
        if (e.isAxiosError && e.response && e.response.data) {
          this.$message.error(e.response.data);
        } else {
          this.$message.error('An unknown error occurred while resending your verification code. Please try again.');
        }
      } finally {
        this.resending = false;
      }
    },
    async onSubmit() {
      this.errorMessage = '';

      try {
        await this.$refs.verificationForm.validate();
      } catch (e) {
        console.warn('validation failed', this.verificationForm);
        return;
      }

      try {
        this.submitting = true;
        const result = await api.docutax.verify(this.clientId, this.verificationForm);

        const jwt = new Jwt(result.data);
        if (!jwt.validate()) {
          this.errorMessage = 'An error occurred while generating an access token for your account. Please try again';
          return;
        }

        jwtService.set(jwt);

        this.$router.push({
          name: 'docutaxSubmission',
          params: {
            clientId: this.clientId,
          },
        });
      } catch (e) {
        if (e.isAxiosError && e.response && e.response.data) {
          this.errorMessage = e.response.data;
        } else {
          this.errorMessage = 'An error occurred, please try again';
        }
      } finally {
        this.submitting = false;
      }
    },
  },
};
</script>

<style lang="scss">
.el-main.home {
  align-items: center;
  padding: 0 0 50px 0;

  .docutax-banner {
    width: 100%;
  }

  .form-container {
    display: flex;
    flex-direction: column;
    align-items: center;

    .el-form {
      width: 100%;
      max-width: 600px;
    }
  }
}
</style>
